import dayjs from "@/lib/dayjs";
type Props = {
	date?: string;
	format?: string;
};

export const getFirstDayOfMonth = ({ date = undefined, format = "YYYY-MM-DD" }: Props) => {
	return dayjs(date).startOf("month").format(format);
};
